import { Directive, input, InputSignal } from '@angular/core';

import { numberKeys } from '@ph-static-data/keyboard-key-codes';

@Directive({
  selector: '[numbersOnly]',
  host: {
    '(keydown)': 'onInputChange($event)',
    '(paste)': 'onPaste($event)',
  }
})
export class NumberDirective {
  numbersOnly: InputSignal<boolean> = input.required();

  private readonly _keycodes = numberKeys;

  onInputChange(ev: KeyboardEvent): void {
    if (this.numbersOnly()) {
      const isCopyPasteAction = (ev.metaKey || ev.ctrlKey) && (ev.key === 'c' || ev.key === 'v');
      if (!this._keycodes.includes(ev.key) && !isCopyPasteAction) {
        ev.preventDefault();
      }
    }
  }

  onPaste(ev: ClipboardEvent): void {
    if (this.numbersOnly()) {
      const win = window as Window & { clipboardData?: DataTransfer | null };
      const clipboardData = ev.clipboardData || win.clipboardData;
      const pastedData = clipboardData?.getData('Text') ?? '';
      const reg = new RegExp('^[0-9]+$');

      if (!reg.test(pastedData)) {
        ev.preventDefault();
      }
    }
  }
}
